import { Firestore } from '@greco-fit/firebase';

export function randomID(firestore: Firestore) {
  return firestore.collection('i').doc().id;
}
